import _u from './util';
import _v from './vars';
import SmoothScroll from 'smooth-scroll';

let dotScrollElems = _u.qS('.slry-avg-like-you, .slry-left-col .slry-abt, .slry-left-col .slry-card');
let cardPosArr = [];
let dotIdx = 0;
let dotClicked = 0;
	
let scrollSpeed = 450;
if (navigator.userAgent.toLowerCase().indexOf('ipad') != -1) {
	scrollSpeed = 850;
}

function getCardPositions(e) {
	cardPosArr = [];
	let adHeaderOffset = 0;
	if (_u.qS('#adtagheader') != null) {		
		adHeaderOffset = _u.qS('#adtagheader').offsetHeight;
	}
	dotScrollElems.forEach(function(elem, idx) {
		if (elem.offsetParent != null) {
			if (idx == 0 && document.body.classList.contains('is-ie')) {
				cardPosArr.push(_u.qS('#headerbox').offsetHeight + adHeaderOffset + _u.qS('.slry-main').offsetTop);
			} else {
				cardPosArr.push(elem.offsetTop + adHeaderOffset + _u.qS('.slry-filt-bar').offsetHeight - 20);
			}
		}
	});
	checkWhichDot();
}

function checkWhichDot(e) {	
	cardPosArr.forEach(function(cardPos, idx) {
		if (window.pageYOffset >= cardPos) {
			dotIdx = idx;
		}
	});
	if (_u.qS('.slry-progress-dot.current') != null && dotIdx != _u.getIndex(_u.qS('.slry-progress-dot.current'))) {
		_u.qS('.slry-progress-dot.current').classList.remove('current');
		_u.qS('.slry-progress-dot')[dotIdx].classList.add('current');
	}
}

function scrollProgress() {
	_u.qS('.slry-progress-bar').style.width = Math.round((window.pageYOffset / (_u.qS('.slry-body').offsetTop + _u.qS('.slry-main').offsetTop + _u.qS('.slry-main').scrollHeight))*100) + '%';
}

function dotClick(idx, popBack) {
	getCardPositions();
	if (typeof cardPosArr[idx] != 'undefined') {
		if (!_v.isScrolling && (dotClicked != dotIdx || Math.abs(window.pageYOffset - cardPosArr[idx]) > 4)) {
			document.removeEventListener('scrollStop', backToDot);
			if (typeof popBack == 'undefined') {
				document.addEventListener('scrollStop', backToDot);
			}
			let scroll = new SmoothScroll(null, { speed: scrollSpeed, easing: 'easeInOutQuad' });
			scroll.animateScroll(cardPosArr[idx]);
			dotClicked = idx;
		}
	}
	else {
		progressInit();
	}
}

function backToDot() {
	document.removeEventListener('scrollStop', backToDot);
	if (dotClicked != dotIdx) {
		dotClick(dotClicked, true);
	}
}

function progressInit(e) {
	
	document.removeEventListener('allWidgetsLoaded', progressInit);
	document.removeEventListener('heightChange', getCardPositions);
	document.removeEventListener('loadWidget', getCardPositions);
	window.removeEventListener('resize', getCardPositions);
	window.removeEventListener('scroll', checkWhichDot);
	window.removeEventListener('scroll', scrollProgress);
	
	_u.qS('.slry-progress-dots').innerHTML = '';
	dotScrollElems.forEach(function(elem, idx) {
		if (elem.offsetParent != null && idx == 0) {
			_u.qS('.slry-progress-dots').appendChild(_u.strToDom('<div class="slry-progress-dot current"></div>'));
		} else if (elem.offsetParent != null) {
			_u.qS('.slry-progress-dots').appendChild(_u.strToDom('<div class="slry-progress-dot"></div>'));
		}
	});
	
	document.addEventListener('allWidgetsLoaded', progressInit);
	document.addEventListener('heightChange', getCardPositions);
	document.addEventListener('loadWidget', getCardPositions);
	window.addEventListener('resize', getCardPositions);
	window.addEventListener('scroll', checkWhichDot);
	window.addEventListener('scroll', scrollProgress);
	getCardPositions();

	if (_u.qS('.slry-progress-dot') != null) {
		_u.qS('.slry-progress-dot').forEach(function(elem, idx) {
			elem.addEventListener('click', function() {
				dotClick(idx);
			});
		});
	}
}

export default progressInit;